export enum WorkingMethod {
  REMOTE = 'REMOTE',
  STATIONARY = 'STATIONARY',
  HYBRID = 'HYBRID'
}